import { DataLayerService } from '@monorepo-channels/shared/util-helpers'
/* eslint-disable no-irregular-whitespace */
import { Component, inject, OnInit } from '@angular/core'
import { MatExpansionModule } from '@angular/material/expansion'
import { RouterOutlet } from '@angular/router'
import { AccordionModule } from '@monorepo-channels/components/ui-common'
import { AbstractComponent } from '@monorepo-channels/channels/domain'
import { MenuOpened } from '@monorepo-channels/shared/util-helpers'
import { CommonModule, Location } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'

@Component({
	standalone: true,
	imports: [
		MatExpansionModule,
		AccordionModule,
		RouterOutlet,
		CommonModule,
		MatButtonModule,
		MatIconModule,
	],
	selector: 'porto-bank-faq-page',
	template: `
		<router-outlet />
		<!-- BACK BUTTON -->
		<main class="container">
			<button (click)="this.location.back()" class="back-button">
				<mat-icon svgIcon="porto-bank-icons:left-arrow"></mat-icon>
				Voltar
			</button>

			<div class="container__content">
				<h1 class="title">FAQ</h1>
				<!-- Accordion Start -->
				<ui-common-accordion
					[collapsing]="false"
					[divisor]="{ show: true, top: '10px', bottom: '10px' }"
					style="
                        --accordion-title-color-active: var(--content-title);
                        --accordion-icon-color-active: var(--content-title);
                        --accordion-header-bg: #BFCCEC;
                        --accordion-header-padding: 20px;
                        --accordion-header-hover: #BFCCEC;
                        --accordion-title-color-active: #2C3DA8;
                    "
				>
					@for (accordion of faq; track accordion.question) {
						<ui-common-accordion-item [title]="accordion.question">
							<ng-template uiCommonAccordionContent>
								<div [innerHTML]="accordion.answer"></div>
							</ng-template>
						</ui-common-accordion-item>
					}
				</ui-common-accordion>

				<div style="height: 100px;"></div>
				<!-- <ui-picpay-footer-buttons type="fixed-order" class="footer-buttons">
                    <button mat-raised-button (click)="this.location.back()">Voltar</button>
                </ui-picpay-footer-buttons> -->
				<!-- Accordion End -->
			</div>
		</main>
	`,
	styleUrl: './faq.page.scss',
})
export class FAQPageComponent extends AbstractComponent implements OnInit {
	public menuOpened = inject(MenuOpened)
	public location = inject(Location)
	private dataLayerService = inject(DataLayerService)

	public faq = [
		{
			question: `O que é o Gastronomia Porto Bank?`,
			answer: `É um benefício que proporciona aos clientes que possuem cartão de crédito Porto Bank, pessoa física ou jurídica, diferenciais em restaurantes selecionados nas cidades de São Paulo, Rio de Janeiro e Belo Horizonte, mediante uso do cartão como forma de reserva ou check-in online e como meio de pagamento nos estabelecimentos participantes listados no site.`,
			isOpened: false,
		},
		{
			question: `Como funciona o Gastronomia Porto Bank?`,
			answer: `Basta escolher um dos restaurantes parceiros e fazer uma reserva ou check-in pelo site <strong>www.gastronomiaportobank.com.br</strong>. Quando chegar ao restaurante, apresente seu nome e reserva para concessão dos benefícios do programa. O desconto/benefício é concedido automaticamente na conta, que deve ser paga integralmente com o cartão de crédito Porto Bank elegível ao programa, utilizado para fazer a reserva.`,
			isOpened: false,
		},
		{
			question: `Quais são os cartões de crédito elegíveis ao Gastronomia Porto Bank?`,
			answer: `Participam do Gastronomia Porto Bank os cartões de crédito emitidos pelo Porto Bank nas bandeiras Visa e Mastercard®:
Porto Bank Mastercard® Black, Porto Bank Visa Infinite, Porto Bank Visa Platinum, Porto Bank Mastercard® Platinum, Porto Bank Visa Gold, Porto Bank Mastercard® Gold, Porto Bank Empresarial Visa Platinum, Porto Bank Empresarial Mastercard® Platinum`,
			isOpened: false,
		},
		{
			question: `É obrigatório fazer a reserva?`,
			answer: `Sim, para ter direito aos diferenciais do Gastronomia Porto Bank é obrigatório fazer a reserva antecipada.`,
			isOpened: false,
		},
		{
			question: `Como realizo uma reserva?`,
			answer: `Você pode fazer sua reserva diretamente pelo site do Gastronomia Porto Bank. A antecedência mínima para reservar é exibida diretamente na tela de reserva do restaurante escolhido. Mediante a confirmação da reserva, há uma tolerância de atraso de até 10 minutos para o comparecimento.`,
			isOpened: false,
		},
		{
			question: `Quando faço a reserva, preciso pagar a conta com o meu cartão de crédito Porto Bank?`,
			answer: `Sim, é imprescindível que a conta seja paga integralmente com o cartão de crédito Porto Bank utilizado para fazer a reserva.`,
			isOpened: false,
		},
		{
			question: `Preciso ligar para o restaurante para confirmar minha reserva?`,
			answer: `Não. As reservas feitas pelo Gastronomia Porto Bank são registradas automaticamente no e-mail cadastrado. Próximo à data da visita, você receberá um novo e-mail para confirmar ou cancelar a reserva. Caso esse e-mail não seja recebido, basta comparecer ao restaurante no horário reservado junto com seus acompanhantes.`,
			isOpened: false,
		},
		{
			question: `Como utilizo a funcionalidade check-in?`,
			answer: `Para a modalidade de benefício check-in, não há necessidade de efetuar uma reserva previamente, apenas realizar uma busca de restaurantes participantes, verificar a disponibilidade e condições dos benefícios do restaurante desejado, efetuar um “check-In” ao sentar-se à mesa no estabelecimento e informar à recepção ou ao garçom para ter acesso aos respectivos benefícios.`,
			isOpened: false,
		},
		{
			question: `Sobre a funcionalidade “check-in”`,
			answer: `
            O check-in permite que você utilize o benefício no seu próprio ritmo. Basta consultar os restaurantes disponíveis, sentar-se à mesa no estabelecimento e clicar no botão “fazer check-in” para aproveitar.
            <br/> <br/>
            Ao utilizar o check-in, você terá acesso ao benefício vigente para aquele momento indicado pelo site e registrado em sua confirmação de uso, o que dependerá única e exclusivamente das regras de cada restaurante participante, as quais deve verificar no site <strong>www.gastronomiaportobank.com.br</strong> antes de comparecer e fazer o “check In”.
            <br/> <br/>
            É necessário saber que, mesmo utilizando um benefício ou recebendo um percentual de desconto, a taxa de serviço (gorjeta) do estabelecimento será calculada com base no valor total da conta antes da aplicação do desconto.
            `,
			isOpened: false,
		},
		{
			question: `Quais são os cartões elegíveis ao Gastronomia Porto Bank?`,
			answer: `O Gastronomia Porto Bank é exclusivo para todos os clientes que possuem cartões de crédito Porto Bank, sejam eles de pessoa física ou jurídica, nas bandeiras Visa e Mastercard®:
Porto Bank Mastercard® Black, Porto Bank Visa Infinite, Porto Bank Visa Platinum, Porto Bank Mastercard® Platinum, Porto Bank Visa Gold, Porto Bank Mastercard® Gold, Porto Bank Empresarial Visa Platinum, Porto Bank Empresarial Mastercard® Platinum`,
			isOpened: false,
		},
		{
			question: `Posso usar à vontade o Gastronomia Porto Bank?`,
			answer: `Sim, você pode usar o Gastronomia Porto Bank quantas vezes quiser! Cada cliente pode fazer uma reserva ou check-in por restaurante por dia.`,
			isOpened: false,
		},
		{
			question: `O que é o desconto?`,
			answer: `O desconto de até 15% é concedido para o titular da reserva ou do check-in, válido exclusivamente para clientes que utilizam um dos cartões de crédito Porto Bank elegíveis e é aplicado sobre o valor total da conta, incluindo entradas, pratos principais, bebidas e sobremesas.
            <br/> 
            O benefício não é cumulativo com outras promoções. Em regra, ele vale para qualquer item do cardápio, porém alguns restaurantes podem não aplicá-lo ao prato executivo por considerarem essa opção como uma oferta promocional.
            <br/>
            Serviços como estacionamento, valet e taxa de serviço não fazem parte do desconto.
            `,
			isOpened: false,
		},
		{
			question: `A taxa de serviço do garçom cobrada pelo restaurante será paga com base no valor do desconto mínimo do programa Gastronomia Porto Bank?`,
			answer: `A taxa de serviço será calculada sobre o preço cheio da conta, ou seja, antes de ser aplicado o desconto mínimo do programa. Uma vez aplicado o desconto será acrescido ao valor total da conta o valor previamente calculado da taxa de serviço do garçom.`,
			isOpened: false,
		},
		{
			question: `Possuo um cartão de crédito Porto Bank adicional e o titular do cartão já possui acesso ao Gastronomia Porto Bank, preciso me cadastrar também?`,
			answer: `Sim. O adicional deve se cadastrar no site do Gastronomia Porto Bank e pagar a conta do restaurante integralmente com o seu cartão de crédito Porto Bank.`,
			isOpened: false,
		},
		{
			question: `Só posso me cadastrar pelo site?`,
			answer: `Sim. O cadastro é realizado exclusivamente pelo site <strong>www.gastronomiaportobank.com.br.</strong> `,
			isOpened: false,
		},
		{
			question: `Como faço para cancelar minha reserva ou check-in?`,
			answer: `Acesse o seu “Histórico” de utilização disponível no menu do lado esquerdo superior, visualize o benefício “Ativo” e selecione “cancelar reserva” ou “cancelar check-in”.`,
			isOpened: false,
		},
		{
			question: `Como faço para cancelar meu cadastro do Gastronomia Porto Bank?`,
			answer: `Para cancelar o cadastro do Gastronomia Porto Bank, é necessário enviar um e-mail para o endereço <strong>gastronomiaportobank@tagme.com.br</strong> solicitando o cancelamento.`,
			isOpened: false,
		},
	]

	ngOnInit(): void {
		this.dataLayerService.logEvent({
			event: 'screen_view',
			screen_name: 'Gastronomia Porto Bank - FAQ',
		})
	}
}
